import { Inbox, RefreshCw } from 'lucide-react';

// Reusable empty-state block — shown whenever a list has zero results
// (no loads, no payments, etc.) instead of just blank space or plain text.
// icon can be overridden per screen if a more specific icon fits better.
function EmptyState({
  icon: Icon = Inbox,
  title = 'Nothing here yet',
  message = '',
  onRetry = null,
  retryLabel = 'Try again',
}) {
  return (
    <div style={styles.wrapper}>
      <div style={styles.iconCircle}>
        <Icon size={32} color="#9ca3af" />
      </div>
      <div style={styles.title}>{title}</div>
      {message && <div style={styles.message}>{message}</div>}
      {onRetry && (
        <button onClick={onRetry} style={styles.retryButton}>
          <RefreshCw size={16} style={{ marginRight: 6 }} />
          {retryLabel}
        </button>
      )}
    </div>
  );
}

const styles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: '60px 24px',
  },
  iconCircle: {
    width: 64,
    height: 64,
    borderRadius: '50%',
    backgroundColor: '#f3f4f6',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 16,
  },
  title: {
    fontSize: 15,
    fontWeight: 700,
    color: '#374151',
    marginBottom: 6,
  },
  message: {
    fontSize: 13,
    color: '#9ca3af',
    marginBottom: 20,
    maxWidth: 260,
  },
  retryButton: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#eff6ff',
    color: '#2563eb',
    border: 'none',
    borderRadius: 10,
    padding: '10px 20px',
    fontSize: 13,
    fontWeight: 700,
    cursor: 'pointer',
  },
};

export default EmptyState;